import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormField } from '../../interfaces/form';
import {IMyDpOptions} from 'mydatepicker';

@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss']
})
export class FormFieldComponent implements OnInit {
  public myDatePickerOptions: IMyDpOptions = {
    // other options...
    dateFormat: 'yyyy-mm-dd'
  };

  @Input()
  userList: Array<any>;

  @Input()
  field: FormField;

  @Input()
  fg: FormGroup;

  constructor() {}

  ngOnInit() {}

  displayFn(item): string {
    return item ? item.title : item;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/form-field/form-field.component.ts